/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const selfEvaluation = useStore((state) => state.selfEvaluation);
  const setSelfEvaluation = useStore((state) => state.setSelfEvaluation);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.selfEvaluation.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={selfEvaluation}
          onChange={(value) => {
            setSelfEvaluation(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'self-evaluation',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Everything's under control"}>
            <span>💪</span> {t('onboarding.selfEvaluation.options.underControl')}
          </Option>
          <Option value={'Sometimes I lose balance'}>
            <span>😅</span> {t('onboarding.selfEvaluation.options.loseBalance')}
          </Option>
          <Option value={'Could be better'}>
            <span>🤷‍♀️</span> {t('onboarding.selfEvaluation.options.couldBeBetter')}
          </Option>
          <Option value={'Just starting to work on it'}>
            <span>🌱</span> {t('onboarding.selfEvaluation.options.justStarting')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
